import api from 'services/api';

const normalizeRows = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (payload && typeof payload === 'object') {
    if (payload.cto_portas && typeof payload.cto_portas === 'object' && Array.isArray(payload.cto_portas.ctos_portas)) {
      return payload.cto_portas.ctos_portas;
    }

    if (Array.isArray(payload.ctos_portas)) {
      return payload.ctos_portas;
    }

    if (Array.isArray(payload.cto_portas)) {
      return payload.cto_portas;
    }

    if (Array.isArray(payload.rows)) {
      return payload.rows;
    }
  }

  return [];
};

class OcupacaoRedeService {
  async buscarCtoPortas(signal = null) {
    const config = signal ? { signal } : {};

    const response = await api.get('/infraestrutura/ocupacao/cto-portas', config);

    return {
      data: {
        cto_portas: normalizeRows(
          response.data?.data
          ?? response.data?.data?.cto_portas
          ?? response.data?.data?.ctos_portas
          ?? response.data
          ?? response.data?.cto_portas
          ?? response.data?.ctos_portas,
        ),
      },
    };
  }
}

const ocupacaoRedeService = new OcupacaoRedeService();

export default ocupacaoRedeService;
